module.exports = __webpack_public_path__ + "img/horse.e0d4884e.svg";